import { StyleSheet } from "aphrodite/no-important";
import { colour, width } from "../style/base-theme";

const buttonDefaults = {
  width: "100%",
  padding: 10,
  display: "block",
  color: "#ffffff",
  textDecoration: "none",
  textAlign: "center",
  fontWeight: 700,
  fontSize: 18,
  border: 0,
  borderRadius: 30,
  cursor: "pointer"
};

export const styles = StyleSheet.create({
  innerNarrow: {
    maxWidth: width.innerNarrow,
    margin: "0 auto",
    padding: "0 20px"
  },
  paddingBottom: {
    paddingBottom: 100
  },
  feedbackContainer: {
    paddingBottom: 100
  },
  appliancesContainer: {
    paddingBottom: 100
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    color: colour.grey[200]
  },
  breakdownTitle: {
    flex: 1,
    fontSize: 16,
    fontWeight: 600,
    color: colour.grey[200],
    marginTop: 25,
    marginBottom: 15,
    display: "flex",
    justifyContent: "space-between"
  },
  breakdownToggle: {
    display: "flex"
  },
  breakdownTitleText: {
    alignSelf: "center",
    marginRight: 10
  },
  breakdownToggleTitle: {
    marginRight: 5,
    alignSelf: "center"
  },
  breakdownToggleLabel: {
    display: "flex",
    margin: "0 10px",
    alignSelf: "center"
  },
  breakdownToggleUnit: {
    alignSelf: "center"
  },
  container: {
    minWidth: 320,
    maxWidth: width.inner,
    margin: "0 auto",
    padding: "0 20px 100px 20px"
  },
  similarTitle: {
    color: "#FFFFFF",
    fontSize: 16,
    margin: 0,
    paddingLeft: 25,
    position: "relative",
    ":before": {
      content: '"\\f526"',
      fontFamily: "informetis",
      fontSize: 14,
      position: "absolute",
      top: 3,
      left: 3
    }
  },
  similarCost: {
    padding: "15px 15px 5px",
    borderRadius: 4,
    background: `linear-gradient(-180deg, ${colour.brand.blue} 0%, ${colour.brand.darkBlue} 97%)`
  },
  similarUsage: {
    padding: "15px 15px 5px",
    borderRadius: 4,
    background: `linear-gradient(-180deg, ${colour.brand.blue} 0%, ${colour.brand.darkBlue} 97%)`
  },
  ul: {
    fontWeight: 600,
    color: colour.grey[300],
    listStyle: "none",
    padding: 0,
    margin: "10px 0",
    lineHeight: 2
  },
  ulWhite: {
    fontWeight: 400,
    color: "#FFFFFF",
    listStyle: "none",
    padding: 0,
    margin: "10px 0",
    lineHeight: 2
  },
  li: {
    position: "relative",
    paddingLeft: 20,
    ":before": {
      content: '"•"',
      position: "absolute",
      fontSize: 24,
      left: 1,
      top: -9,
      opacity: 0.3
    }
  },
  buttonGreen: {
    ...buttonDefaults,
    background: colour.brand.green
  },
  highlightCost: {
    color: colour.brand.blue
  },
  highlightUsage: {
    color: colour.brand.blue
  },
  hidden: {
    opacity: 0,
    pointerEvents: "none",
    height: 0
  }
});
